<!-- 新增临时证照 -->
<template>
    <div>
        <el-form :model="sendDataInfo" ref="sendDataInfo" label-width="100px" size="mini" :show-message="false">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="商品名称" prop="bgmName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                        <el-input clearable v-model="sendDataInfo.bgmName" @input="$common.clearSearch(sendDataInfo, 'bgmName,bgmCode,bgmId,spec,manufacturer', 'bgmName')"
                            @clear="$common.clearSearch(sendDataInfo, 'bgmName,bgmCode,bgmId,spec,manufacturer')" @keyup.enter.native="openSearch(4439374514425856, 'bgmName', 'bgmName,bgmCode,bgmId,spec,manufacturer')">
                            <el-button slot="append" icon="el-icon-search" @click="openSearch(4439374514425856, 'bgmName', 'bgmName,bgmCode,bgmId,spec,manufacturer')">
                            </el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="商品编号">
                        <el-input v-model="sendDataInfo.bgmCode" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="规格">
                        <el-input v-model="sendDataInfo.spec" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="生产厂商">
                        <el-input v-model="sendDataInfo.manufacturer" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证照类型" prop="lityId" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                        <el-select v-model="sendDataInfo.lityId" placeholder="请选择" clearable filterable style="width: 100%;">
                            <el-option v-for="item in LicensetypeList" :key="item.lityId" :label="item.lityName" :value="item.lityId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="有效期至" prop="tervalidity" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                        <el-date-picker v-model="sendDataInfo.tervalidity" type="date" value-format="timestamp" format="yyyy 年 MM 月 dd 日" placeholder="选择日期" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model.trim="sendDataInfo.remark" maxlength="200" :rows="3"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div style="text-align: center; margin-top: 10px;">
            <el-button size="mini" @click="cancel">取 消</el-button>
            <el-button type="primary" size="mini" @click="sendDataAction">保 存</el-button>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body="true" :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "licenseexpiAdd",
    components: {
        SearchScheme,
    },
    data() {
        return {
            sendDataInfo: {
                bgmId: "",
                bgmName: "",
                bgmCode: "",
                spec: "",
                manufacturer: "",
                lityId: "",
                remark: "",
                tervalidity: "",
            },
            LicensetypeList: [],
            seId: "",
            seTitle: "",
            seWidth: "70%",
            seType: "",
            sField: "",
            DialogVisible: false,
            parentSearchData: {},
        };
    },
    created() {
        this.getLicensetypeList();
    },
    methods: {
        init() {
            this.sendDataInfo = {
                bgmId: "",
                bgmName: "",
                bgmCode: "",
                spec: "",
                manufacturer: "",
                lityId: "",
                remark: "",
                tervalidity: "",
            };
            this.$nextTick(() => {
                if (this.$refs.sendDataInfo) {
                    this.$refs.sendDataInfo.clearValidate();
                }
            });
        },
        // 查询证照类型
        async getLicensetypeList() {
            this.LicensetypeList = [];
            let responseData = await this.$http.getPartDictionariesData({
                ids: [30],
            });
            if (responseData.status == 200) {
                const result = responseData.result.spzzlx || [];
                this.LicensetypeList = result.map((v) => ({
                    lityId: v.diValue,
                    lityName: v.diName,
                }));
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        openSearch(sId, type, sField) {
            this.seId = sId;
            this.seType = type;
            this.sField = sField;
            this.parentSearchData = {
                bgmName: this.sendDataInfo.bgmName || "",
                manufacturer: "",
            };
            if (this.parentSearchData.bgmName) {
                let fh = 0;
                if (this.parentSearchData.bgmName.indexOf(",") != -1) {
                    fh = ",";
                } else if (this.parentSearchData.bgmName.indexOf("，") != -1) {
                    fh = "，";
                }
                if (fh !== 0) {
                    const list = this.parentSearchData.bgmName.split(fh);
                    this.parentSearchData.bgmName = list[0] || "";
                    this.parentSearchData.manufacturer = list[1] || "";
                }
            }
            this.DialogVisible = true;
        },
        changeInputModel(val) {
            if (val != "" && val != undefined) {
                this.DialogVisible = false;
                const fields = this.sField.split(",");
                fields.forEach((item) => {
                    if (val[item] != undefined && val[item] != null) {
                        this.$set(this.sendDataInfo, item, val[item]);
                    }
                });
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        sendDataAction() {
            this.$refs.sendDataInfo.validate((valid) => {
                if (!valid) {
                    return this.$message({
                        message: "请完善必填项",
                        type: "warning",
                    });
                }
                if (!this.sendDataInfo.bgmId) {
                    return this.$message({
                        message: "请通过检索选择商品",
                        type: "warning",
                    });
                }
                this.sub();
            });
        },
        async sub() {
            const sendData = {
                bgmId: this.sendDataInfo.bgmId,
                lityId: this.sendDataInfo.lityId,
                remark: this.sendDataInfo.remark || "",
                tervalidity: this.sendDataInfo.tervalidity ? new Date(this.sendDataInfo.tervalidity).getTime() + 1000 * 60 * 60 * 24 - 1 : "",
            };
            const responseData = await this.$http.licenseExpiadd(sendData);
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.init();
                this.$emit("close");
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        cancel() {
            this.init();
            this.$emit("close");
        },
    },
};
</script>
